/*
================================================
Un mixin pour la gestion des projets
https://fr.vuejs.org/v2/guide/mixins.html
================================================
*/

var  ProjectMixin = {
    created(){
        // this.hello()
    },

    data: function () {
        return {
            name: 'ProjectMixin',
        }
    },
    methods: {
        hello: function () {
            // alert(`hello ;) "${this.name}" is loaded !`)
        },


        /**
         * Calcule le pourcentage de complétion d'un projet (temps passé/prévu)
         * @param project Object un objet project
         */
        calculateProjectPercent(project){

            let estimatedHours
            let spentHours
            project.duration != null ? spentHours = this.$moment.duration(project.duration).asHours() : spentHours = 0
            project.estimate != undefined ? estimatedHours = project.estimate : estimatedHours = 0

            let res
            if (estimatedHours === 0 || spentHours === 0) {
                res = 0
            } else {

                res =  parseFloat(spentHours.toFixed(2)) * 100 / parseInt(estimatedHours)
            }
            return Math.round(res)
        },

        /**
         * Retourn une couleur selon percent
         * @param project Object un objet project
         */
        colorByPercent: function (project){

            let percent = this.calculateProjectPercent(project)

            if(project.estimate != null){

                //
                if (percent <51){
                    return 'under50'
                }
                else if (percent <=69){
                    return 'under70'
                }
                else if(percent >= 70 && percent <= 99){
                    return 'under100'
                }
                else if (percent > 99){
                    return 'over100'
                }
            }

        }
    },

}

export default ProjectMixin;

